import { render } from "./Funcao.vue?vue&type=template&id=24a2d1e8"
import script from "./Funcao.vue?vue&type=script&lang=js"
export * from "./Funcao.vue?vue&type=script&lang=js"

import exportComponent from "D:\\DealDesk\\Homologação\\Mult_Cliente\\front_mult_clint\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__